<template>
  <v-sheet
    v-if="editedIndex != -1"
    class="mx-auto"
    elevation="8"
    max-width="1200"
  >
    <v-slide-group
      v-model="modelhojas"
      class="pa-4"
      selected-class="bg-success"
      show-arrows
    >
      <v-slide-group-item
        v-for="n in sheet"
        :key="n"
        v-slot="{ toggle, selectedClass }"
      >
        <v-card
          color="blue-lighten-4"
          :class="['ma-4', selectedClass]"
          height="70"
          width="140"
          @click="
            toggle();
            editItem(n);
          "
        >
          <v-card-item>
            <div>
              <div align="center" class="text-caption">
                <v-icon> {{ n.icono }} </v-icon>
              </div>
              <div align="center" class="text-caption">
                {{ n.descripcion }}
              </div>
            </div>
          </v-card-item>
        </v-card>
      </v-slide-group-item>
    </v-slide-group>
  </v-sheet>
  <!-- Tablero de control -->
  <v-form ref="form" autocomplete="off">
    <v-expansion-panels v-model="panel" multiple>
      <!--////////////////////////////////////////////// Identificación ////////////////////////////////////////////////////////////-->
      <v-expansion-panel>
        <v-expansion-panel-title
          ><h2 align="center">
            <v-icon color="#B6332E" large> mdi-information </v-icon>
            Identificación
          </h2></v-expansion-panel-title
        >
        <v-expansion-panel-text>
          <v-row>
            <!--Sucursal-->
            <v-col cols="12" sm="6" md="4">
              <v-autocomplete
                v-model="editedItem.SucursalID"
                :items="ArraySucursalId"
                :item-title="
                  (ArraySucursalId) =>
                    ArraySucursalId.SucursalId +
                    '-' +
                    ArraySucursalId.Descripcion
                "
                item-value="SucursalId"
                color="primary"
                label="Sucursal:"
                dense
                :rules="[(v) => !!v || 'Campo obligatorio']"
                clearable
              >
              </v-autocomplete>
            </v-col>
            <!--Fecha De Inicio De Administración-->
            <v-col cols="12" sm="12" md="4">
              <v-text-field
                v-model="editedItem.FechaIniAdministracion"
                label="Fecha de Inicio de Administración:"
                type="date"
                :rules="[(v) => !!v || 'Campo obligatorio']"
                clearable
              ></v-text-field>
            </v-col>
            <!--Producto-->
            <v-col cols="12" sm="6" md="4">
              <v-autocomplete
                v-model="editedItem.ProductoID"
                :items="ArrayProductoId"
                :item-title="
                  (ArrayProductoId) =>
                    ArrayProductoId.ProductoID +
                    '-' +
                    ArrayProductoId.Descripcion
                "
                item-value="ProductoID"
                color="primary"
                label="Producto:"
                dense
                :rules="[(v) => !!v || 'Campo obligatorio']"
                clearable
              >
              </v-autocomplete>
            </v-col>
            <!--Contrato-->
            <v-col cols="12" sm="6" md="6">
              <v-text-field
                v-model="editedItem.ContratoID"
                label="Contrato:"
                hint="Digite Información"
                dense
                :rules="[(v) => !!v || 'Campo obligatorio']"
                :clearable="clearcampos.Contrato_ID"
                :readonly="readcampos.Contrato_ID"
                maxlength="20"
                counter="20"
              >
              </v-text-field>
            </v-col>
            <!--Descripcion-->
            <v-col cols="12" sm="6" md="6">
              <v-text-field
                v-model="editedItem.Descripcion"
                label="Descripción:"
                hint="Digite Información"
                :rules="[(v) => !!v || 'Campo obligatorio']"
                dense
                clearable
                maxlength="200"
                counter="200"
              >
              </v-text-field>
            </v-col>
            <!--Estado-->
            <v-col cols="12" sm="6" md="6">
              <v-autocomplete
                v-model="editedItem.EstadoContrato"
                :items="ArrayEstado"
                :item-title="
                  (ArrayEstado) =>
                    ArrayEstado.Valor + '-' + ArrayEstado.Descripcion
                "
                item-value="Valor"
                color="primary"
                label="Estado:"
                dense
                :rules="[(v) => !!v || 'Campo obligatorio']"
                clearable
              >
              </v-autocomplete>
            </v-col>
            <!--Novedad-->
            <v-col cols="12" sm="6" md="6">
              <v-autocomplete
                v-model="editedItem.NovedadContrato"
                :items="ArrayNovedad"
                :item-title="
                  (ArrayNovedad) =>
                    ArrayNovedad.Valor + '-' + ArrayNovedad.Descripcion
                "
                item-value="Valor"
                color="primary"
                label="Novedad:"
                dense
                clearable
              >
              </v-autocomplete>
            </v-col>
            <!--Tipo Servicio-->
            <v-col cols="12" sm="6" md="6">
              <v-autocomplete
                v-model="editedItem.TipoServicio"
                :items="ArrayTipoServicio"
                :item-title="
                  (ArrayTipoServicio) =>
                    ArrayTipoServicio.Valor +
                    '-' +
                    ArrayTipoServicio.Descripcion
                "
                item-value="Valor"
                color="primary"
                label="Tipo de Servicio:"
                dense
                :rules="[(v) => !!v || 'Campo obligatorio']"
                clearable
              >
              </v-autocomplete>
            </v-col>
            <!--Tipo Servicio Origen-->
            <v-col cols="12" sm="6" md="6">
              <v-autocomplete
                v-model="editedItem.TipoServicioOrigen"
                :items="ArrayTipoServicio"
                :item-title="
                  (ArrayTipoServicio) =>
                    ArrayTipoServicio.Valor +
                    '-' +
                    ArrayTipoServicio.Descripcion
                "
                item-value="Valor"
                color="primary"
                label="Tipo de Servicio Origen:"
                dense
                :rules="[(v) => !!v || 'Campo obligatorio']"
                clearable
              >
              </v-autocomplete>
            </v-col>
            <!--Base Calculo-->
            <v-col cols="12" sm="6" md="2">
              <v-autocomplete
                v-model="editedItem.BaseCalculoID"
                :items="ArrayDesBaseCalculo"
                :item-title="
                  (ArrayDesBaseCalculo) =>
                    ArrayDesBaseCalculo.Valor +
                    '-' +
                    ArrayDesBaseCalculo.Descripcion
                "
                item-value="Valor"
                color="primary"
                label="Base Calculo:"
                dense
                clearable
                :rules="[(v) => !!v || 'Campo obligatorio']"
              >
              </v-autocomplete>
            </v-col>
            <!--Unidad De Tiempo-->
            <v-col cols="12" sm="6" md="2">
              <v-autocomplete
                v-model="editedItem.UnidadTiempoID"
                :items="ArrayDesUnidadTiempo"
                :item-title="
                  (ArrayDesUnidadTiempo) =>
                    ArrayDesUnidadTiempo.Valor +
                    '-' +
                    ArrayDesUnidadTiempo.Descripcion
                "
                item-value="Valor"
                color="primary"
                label="Unidad De Tiempo:"
                dense
                clearable
                :rules="[(v) => !!v || 'Campo obligatorio']"
              >
              </v-autocomplete>
            </v-col>
            <!--Fecha De Desembolso-->
            <v-col cols="12" sm="12" md="3">
              <v-text-field
                v-model="editedItem.FechaDesembolso"
                label="Fecha de Desembolso:"
                type="date"
                clearable
                :rules="[(v) => !!v || 'Campo obligatorio']"
              ></v-text-field>
            </v-col>
            <!--Plazo-->
            <v-col cols="12" sm="6" md="2">
              <v-text-field
                v-model="editedItem.Plazo"
                label="Plazo:"
                hint="Digite Información"
                dense
                clearable
              >
              </v-text-field>
            </v-col>
            <!--Fecha De Vencimiento-->
            <v-col cols="12" sm="12" md="3">
              <v-text-field
                v-model="editedItem.FechaVencimiento"
                label="Fecha de Vencimiento:"
                type="date"
                clearable
                :rules="[(v) => !!v || 'Campo obligatorio']"
              ></v-text-field>
            </v-col>
            <!--Valor Total-->
            <v-col cols="12" sm="6" md="4">
              <v-text-field
                v-model="editedItem.ValorTotal"
                label="Valor Total:"
                type="number"
                hint="Digite Información"
                :rules="[(v) => !!v || 'Campo obligatorio']"
                dense
                v-on:keypress="isNumber()"
                clearable
                maxlength="17"
                counter="17"
              >
              </v-text-field>
            </v-col>
            <!--Valor Financiado-->
            <v-col cols="12" sm="6" md="4">
              <v-text-field
                v-model="editedItem.ValorFinanciado"
                label="Valor Financiado:"
                type="number"
                hint="Digite Información"
                dense
                v-on:keypress="isNumber()"
                :rules="[(v) => !!v || 'Campo obligatorio']"
                clearable
                maxlength="15"
                counter="15"
              >
              </v-text-field>
            </v-col>
            <!--Opcion De Compra-->
            <v-col cols="12" sm="6" md="4">
              <v-text-field
                v-model="editedItem.ValorOpcCompra"
                label="Valor opción de Compra:"
                type="number"
                hint="Digite Información"
                dense
                :rules="[(v) => !!v || 'Campo obligatorio']"
                clearable
                maxlength="15"
                counter="15"
              >
              </v-text-field>
            </v-col>
          </v-row>
        </v-expansion-panel-text>
      </v-expansion-panel>
      <!--//////////////////////////////////////////////  Comunicaciones físicas ////////////////////////////////////////////////////////////-->
      <v-expansion-panel>
        <v-expansion-panel-title
          ><h2 align="center">
            <v-icon color="#B6332E" large> mdi-phone-message </v-icon>
            Comunicaciones físicas
          </h2></v-expansion-panel-title
        >
        <v-expansion-panel-text>
          <v-row>
            <!--Tipo de documento-->
            <v-col cols="12" sm="6" md="4">
              <v-autocomplete
                v-model="editedItem.TypeDocumentID"
                :items="ArrayTypeDocument_ID"
                :item-title="
                  (ArrayTypeDocument_ID) =>
                    ArrayTypeDocument_ID.Valor +
                    '-' +
                    ArrayTypeDocument_ID.Descripcion
                "
                item-value="Valor"
                color="primary"
                label="Tipo de documento:"
                dense
                clearable
                :rules="[(v) => !!v || 'Campo obligatorio']"
              >
              </v-autocomplete>
            </v-col>
            <!--Documento-->
            <v-col cols="12" sm="6" md="4">
              <v-text-field
                v-model="editedItem.DocumentID"
                label="Documento"
                hint="Digite Información"
                dense
                @change="ChangeDocumento_ID()"
                :rules="[(v) => !!v || 'Campo obligatorio']"
                clearable
                maxlength="20"
                counter="20"
              >
              </v-text-field>
            </v-col>
            <!--Nombre-->
            <v-col cols="12" sm="6" md="4">
              <span>Nombre: {{ NombrePersona }}</span>
            </v-col>
            <!--Direccion Principal-->
            <v-col cols="12" sm="6" md="6">
              <v-autocomplete
                v-model="editedItem.DireccionID"
                :items="ArrayDireccion"
                :item-title="
                  (ArrayDireccion) =>
                    ArrayDireccion.DireccionID +
                    '-' +
                    ArrayDireccion.ComplementoDireccion +
                    '-' +
                    ArrayDireccion.NombreConjunto
                "
                item-value="DireccionID"
                color="primary"
                label="Direccion Pricipal:"
                dense
                :rules="[(v) => !!v || 'Campo obligatorio']"
                clearable
              >
              </v-autocomplete>
            </v-col>
            <!--Ciclo De Comunicacion-->
            <v-col cols="12" sm="6" md="6">
              <v-autocomplete
                v-model="editedItem.CicloID"
                :items="ArrayCicloId"
                :item-title="
                  (ArrayCicloId) =>
                    ArrayCicloId.CodigoCiclo +
                    '-' +
                    ArrayCicloId.DescripcionCiclo
                "
                item-value="CodigoCiclo"
                color="primary"
                label="Ciclo De Comunicación:"
                dense
                :rules="[(v) => !!v || 'Campo obligatorio']"
                @change="ChangeCiclo()"
                clearable
              >
              </v-autocomplete>
            </v-col>
          </v-row>
        </v-expansion-panel-text>
      </v-expansion-panel>
    </v-expansion-panels>
    <!--////////////////////////////////////////////// Auditoria ////////////////////////////////////////////////////////////-->
    <br />
    <v-row>
      <v-col v-if="editedIndex != -1" cols="12" sm="12" md="6">
        <span>Usuario Creación: {{ editedItem.UsuarioCreacion }}</span>
      </v-col>
      <v-col v-if="editedIndex != -1" cols="12" sm="12" md="6">
        <span
          >Usuario Actualización: {{ editedItem.UsuarioActualizacion }}</span
        >
      </v-col>
      <v-col v-if="editedIndex != -1" cols="12" sm="12" md="6">
        <span>Fecha Creación: {{ editedItem.FechaCreacion }}</span>
      </v-col>
      <v-col v-if="editedIndex != -1" cols="12" sm="12" md="6">
        <span>Fecha Actualización: {{ editedItem.FechaActualizacion }}</span>
      </v-col>
    </v-row>
    <div align="right">
      <br />
      <v-btn
        size="x-large"
        v-if="!buttonSave"
        color="green"
        text
        @click="ValidateCampos"
      >
        Guardar
      </v-btn>
    </div>
  </v-form>
  <!-- Linea de progreso -->
  <div class="d-flex align-center flex-column">
    <v-dialog v-model="progreso" persistent width="auto">
      <v-card color="red-darken-4">
        <v-card-text>
          Espera un momento...
          <v-toolbar align="center" color="red-darken-4">
            <v-img
              class="mx-auto"
              :width="5"
              src="/static/iconos/logo2.png"
            ></v-img>
          </v-toolbar>
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
export default {
  name: "clientes_registro",
  props: {
    editedIndex: {
      type: Number,
      default: 0,
      Description: "Cambia de actualización a creación o visceversa",
    },
    infoedit: {
      type: Object,
      default: [],
      Description: "Información de datos",
    },
    infollaves: {
      type: Object,
      default: null,
      Description: "Información de llaves",
    },
    llavesiframe: {
      type: Object,
      default: null,
      Description: "Información de llaves",
    },
    page: {
      type: Boolean,
      default: false,
      Description: "Saber desde donde se llama la página",
    },
    pageiframe: {
      type: Boolean,
      default: false,
      Description: "LLamado a Página Iframe",
    },
    componenteview: {
      type: Number,
      default: 0,
      Description: "Saber a que página llamar",
    },
    iconodialogbtn: {
      type: String,
      default: null,
      Description: "Información icono iframe",
    },
    titledialogbtn: {
      type: String,
      default: null,
      Description: "Información titulo iframe",
    },
    Exito: {
      type: String,
      default: null,
      Description: "Información de respuesta post o put",
    },
  },
  data() {
    return {
      panel: [0, 1],
      progreso: false,
      componenteview: 0,
      modelhojas: null,
      consult: false,
      sheet: [
        {
          icono: "mdi-file-replace",
          descripcion: "Relación Contrato Activo",
          iconoelegido: 1,
        },
        {
          icono: "mdi-account-multiple",
          descripcion: "Relación Actores",
          iconoelegido: 2,
        },
        {
          icono: "mdi-account",
          descripcion: "Clientes",
          iconoelegido: 3,
        },
        {
          icono: "mdi-home-group",
          descripcion: "Activos",
          iconoelegido: 4,
        },
        {
          icono: "mdi-account-lock",
          descripcion: "Seguros",
          iconoelegido: 5,
        },
        {
          icono: "mdi-folder-open",
          descripcion: "Anexar Documento",
          iconoelegido: 6,
        },
        {
          icono: "mdi-file-search",
          descripcion: "Consulta documentos",
          iconoelegido: 7,
        },
      ],
      buttonSave: false,
      editedItem: {
        SucursalID: null,
        ContratoID: null,
        Descripcion: null,
        MonedaID: null,
        ProductoID: null,
        CondiFinanciacionID: null,
        PuntosAdicionales: null,
        UnidadTiempoID: null,
        BaseCalculoID: null,
        FechaApertura: null,
        FechaDesembolso: null,
        Plazo: null,
        FechaVencimiento: null,
        FechaIniAdministracion: null,
        FechaProceso: null,
        CicloID: null,
        TypeDocumentID: null,
        DocumentID: null,
        DireccionID: null,
        ValorTotal: null,
        ValorFinanciado: null,
        ValorOpcCompra: null,
        EstadoContrato: null,
        TipoServicio: null,
        TipoServicioOrigen: null,
        NovedadContrato: null,
        UsuarioCreacion: null,
        FechaCreacion: null,
        UsuarioActualizacion: null,
        FechaActualizacion: null,
      },
      defaultItem: {
        SucursalID: null,
        ContratoID: null,
        Descripcion: null,
        MonedaID: null,
        ProductoID: null,
        CondiFinanciacionID: null,
        PuntosAdicionales: null,
        UnidadTiempoID: null,
        BaseCalculoID: null,
        FechaApertura: null,
        FechaDesembolso: null,
        Plazo: null,
        FechaVencimiento: null,
        FechaIniAdministracion: null,
        FechaProceso: null,
        CicloID: null,
        TypeDocumentID: null,
        DocumentID: null,
        DireccionID: null,
        ValorTotal: null,
        ValorFinanciado: null,
        ValorOpcCompra: null,
        EstadoContrato: null,
        TipoServicio: null,
        TipoServicioOrigen: null,
        NovedadContrato: null,
        UsuarioCreacion: null,
        FechaCreacion: null,
        UsuarioActualizacion: null,
        FechaActualizacion: null,
      },
      clearcampos: {
        Contrato_ID: true,
      },
      readcampos: {
        Contrato_ID: false,
      },
      llaves: {
        TypeDocument_ID: null,
        Document_ID: null,
        Primer_Apellido: null,
        Segundo_Apellido: null,
        Primer_Nombre: null,
        Segundo_Nombre: null,
        Solicitud: null,
        Contrato: null,
        Ref_1: null,
        Ref_2: null,
        Ref_3: null,
        IDServicio: null,
        IDPoliza: null,
        Secuencia_ID: null,
      },
      ArrayTypeDocument_ID: [],
      ArrayDesUnidadTiempo: [],
      ArrayDesBaseCalculo: [],
      ArrayEstado: [],
      ArrayTipoServicio: [],
      ArrayNovedad: [],
      ArraySucursalId: [],
      ArrayProductoId: [],
      ArrayCicloId: [],
      ArrayDireccion: [],
      NombrePersona: null,
    };
  },
  methods: {
    // Convertir a numero
    isNumber: function (evt) {
      evt = evt || window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    ///////////////////////////////////////////////// Métodos de consulta ///////////////////////////////////////////
    // Item editar
    editItem(item) {
      var data = true;
      this.$emit("update:componenteview", item.iconoelegido);
      this.$emit("update:iconodialogbtn", item.icono);
      this.$emit("update:titledialogbtn", item.descripcion);
      this.$emit("update:pageiframe", data);
      switch (item.iconoelegido) {
        case 3: //Clientes
          this.llaves.TypeDocument_ID = this.editedItem.TypeDocumentID;
          this.llaves.Document_ID = this.editedItem.DocumentID;
          break;
        case 4: //Activos
          this.llaves.TypeDocument_ID = this.editedItem.TypeDocumentID;
          this.llaves.Document_ID = this.editedItem.DocumentID;
          break;
        case 5: //Seguros
          this.llaves.TypeDocument_ID = this.editedItem.TypeDocumentID;
          this.llaves.Document_ID = this.editedItem.DocumentID;
          this.llaves.Contrato = this.editedItem.ContratoID;
          break;
      }
      this.$emit("update:llavesiframe", this.llaves);
    },
    // Validación de campos
    async ValidateCampos() {
      var validate = false;
      if (
        this.editedItem.SucursalID == "" ||
        this.editedItem.SucursalID == null ||
        this.editedItem.ProductoID == "" ||
        this.editedItem.ProductoID == null ||
        this.editedItem.CicloID == "" ||
        this.editedItem.CicloID == null ||
        this.editedItem.FechaDesembolso == "" ||
        this.editedItem.FechaDesembolso == null ||
        this.editedItem.FechaVencimiento == "" ||
        this.editedItem.FechaVencimiento == null ||
        this.editedItem.ContratoID == "" ||
        this.editedItem.ContratoID == null ||
        this.editedItem.TypeDocumentID == "" ||
        this.editedItem.TypeDocumentID == null ||
        this.editedItem.DocumentID == "" ||
        this.editedItem.DocumentID == null ||
        this.editedItem.DireccionID == "" ||
        this.editedItem.DireccionID == null ||
        this.editedItem.ValorTotal == "" ||
        this.editedItem.ValorTotal == null ||
        this.editedItem.FechaIniAdministracion == "" ||
        this.editedItem.FechaIniAdministracion == null ||
        this.editedItem.Descripcion == "" ||
        this.editedItem.Descripcion == null ||
        this.editedItem.UnidadTiempoID == "" ||
        this.editedItem.UnidadTiempoID == null ||
        this.editedItem.BaseCalculoID == "" ||
        this.editedItem.BaseCalculoID == null ||
        this.editedItem.ValorFinanciado == "" ||
        this.editedItem.ValorFinanciado == null ||
        this.editedItem.ValorOpcCompra == "" ||
        this.editedItem.ValorOpcCompra == null ||
        this.editedItem.EstadoContrato == "" ||
        this.editedItem.EstadoContrato == null //||
        // this.editedItem.NovedadContrato == "" ||
        //this.editedItem.NovedadContrato == null
      ) {
        validate = true;
      } else if (
        this.editedItem.TypeDocumentID != "" &&
        this.editedItem.TypeDocumentID != null &&
        this.editedItem.DocumentID != "" &&
        this.editedItem.DocumentID != null &&
        (this.NombrePersona == "" || this.NombrePersona == null)
      ) {
        validate = true;
      }
      // Consultas a Ejecutar
      if (!validate) {
        var userperfil = this.$store.getters.userperfil;
        this.editedItem.UsuarioActualizacion = userperfil.userInfo.Usuario_ID;
        this.editedItem.UsuarioCreacion = userperfil.userInfo.Usuario_ID;
        if (this.editedIndex != -1) {
          this.putRegistro();
        } else {
          this.postRegistro();
        }
      } else {
        this.$swal({
          icon: "warning",
          title: "Campos Incompletos.",
          html: " Hay campos que se encuentran incompletos o no contiene el respecitivo filtro.",
        });
        this.$refs.form.validate();
      }
    },
    // Crear Registro
    async postRegistro() {
      this.progreso = true;
      this.axios
        .post("/ActivosO/Contratos/CR0/", this.editedItem)
        .then((result) => {
          this.reset();
          var data = false;
          this.$emit("update:page", data);
          this.$emit("update:Exito", result.data);
          this.$swal({
            icon: "success",
            title: "¡Éxito!",
            html: " El registro fue guardado correctamente.",
          });
        })
        .catch((error) => {
          const registro = error.response.data;
          const mensajeerror =
            registro.Mensaje || registro.ExceptionMessage || registro;
          switch (error.response.status) {
            case 404:
              this.$swal({
                icon: "warning",
                title: "Consulta inexistente.",
                html: mensajeerror,
              });
              break;
            default:
              this.$swal({
                icon: "error",
                title: "Error al consultar",
                html:
                  " El sistena ha encontrado la siguiente condicion inesperada: <br><small><code>" +
                  mensajeerror +
                  "</code></small>",
              });
              break;
          }
        })
        .finally(() => {
          this.progreso = false;
        });
    },
    // Actualizacion de registro
    async putRegistro() {
      this.progreso = true;
      console.log(this.editedItem);
      this.axios
        .put("/ActivosO/Contratos/UP0", this.editedItem)
        .then((response) => {
          this.reset();
          var data = false;
          this.$emit("update:page", data);
          this.$emit("update:Exito", response.data);
          this.$swal({
            icon: "success",
            title: "¡Éxito!",
            html: " El registro fue guardado correctamente.",
          });
        })
        .catch((error) => {
          const registro = error.response.data;
          const mensajeerror =
            registro.Mensaje || registro.ExceptionMessage || registro;
          switch (error.response.status) {
            case 404:
              this.$swal({
                icon: "warning",
                title: "Consulta inexistente.",
                html: mensajeerror,
              });
              break;
            default:
              this.$swal({
                icon: "error",
                title: "Error al consultar",
                html:
                  " El sistena ha encontrado la siguiente condicion inesperada: <br><small><code>" +
                  mensajeerror +
                  "</code></small>",
              });
              break;
          }
        })
        .finally(() => {
          this.progreso = false;
        });
    },
    // Get para obtener nombre de la persona
    async getNombrePersona() {
      this.NombrePersona = null;
      if (
        this.editedItem.TypeDocumentID != "" &&
        this.editedItem.TypeDocumentID != null &&
        this.editedItem.DocumentID != "" &&
        this.editedItem.DocumentID != null
      ) {
        this.axios
          .get(
            "/Personas/Cliente/CD1/" +
              this.editedItem.TypeDocumentID +
              "/" +
              this.editedItem.DocumentID
          )
          .then((response) => {
            this.NombrePersona = response.data;
          })
          .catch((error) => {
            const registro = error.response.data;
            const mensajeerror =
              registro.Mensaje || registro.ExceptionMessage || registro;
            switch (error.response.status) {
              case 404:
                this.$swal({
                  icon: "warning",
                  title: "Consulta inexistente.",
                  html: mensajeerror,
                });
                break;
              default:
                this.$swal({
                  icon: "error",
                  title: "Error al consultar",
                  html:
                    " El servidor ha encontrado la siguiente condicion inesperada: <br><small><code>" +
                    mensajeerror +
                    "</code></small>",
                });
                break;
            }
          });
      }
    },
    // Get para obtener direcciones
    async getDireccionPrincipal() {
      this.ArrayDireccion = [];
      if (
        this.editedItem.TypeDocumentID != "" &&
        this.editedItem.TypeDocumentID != null &&
        this.editedItem.DocumentID != "" &&
        this.editedItem.DocumentID != null
      ) {
        this.axios
          .get(
            "/Personas/Direcciones/CD1/" +
              this.editedItem.TypeDocumentID +
              "/" +
              this.editedItem.DocumentID
          )
          .then((response) => {
            this.ArrayDireccion = response.data;
          })
          .catch((error) => {
            const registro = error.response.data;
            const mensajeerror =
              registro.Mensaje || registro.ExceptionMessage || registro;
            switch (error.response.status) {
              case 404:
                this.$swal({
                  icon: "warning",
                  title: "Consulta inexistente.",
                  html: mensajeerror,
                });
                break;
              default:
                this.$swal({
                  icon: "error",
                  title: "Error al consultar",
                  html:
                    " El servidor ha encontrado la siguiente condicion inesperada: <br><small><code>" +
                    mensajeerror +
                    "</code></small>",
                });
                break;
            }
          });
      }
    },
    /////////////////////////////////////////////// Métodos Changes ///////////////////////////////////////////////
    // Change Documento
    ChangeDocumento_ID() {
      if (
        this.editedItem.DocumentID == "" ||
        this.editedItem.DocumentID == null
      ) {
        this.NombrePersona = null;
        this.editedItem.DireccionID = null;
      } else {
        this.getNombrePersona();
        this.getDireccionPrincipal();
      }
    },
    ///////////////////////////////////////////////// Métodos de acciones ///////////////////////////////////////////
    reset() {
      this.editedItem = Object.assign({}, this.defaultItem);
      this.CantidadViculo = 0;
      this.wtipopersona = null;
    },
    // Cargue Combos
    CargueCombos() {
      var TipoDocumento = this.$store.getters.MTablaSeleccion;
      this.ArrayTypeDocument_ID = TipoDocumento.filter(
        (item) => item.Valor != null && item.TablaId == 2
      ).map((item) => ({
        ...item,
        Valor: parseInt(item.Valor), // o Number(item.Valor) si lo prefieres
      }));

      var Estado = this.$store.getters.MTablaSeleccion;
      this.ArrayEstado = Estado.filter(
        (item) => item.Valor != null && item.TablaId == 7
      ).map((item) => ({
        ...item,
        Valor: parseInt(item.Valor), // o Number(item.Valor) si prefieres mantener decimales
      }));

      var Novedad = this.$store.getters.MTablaSeleccion;
      this.ArrayNovedad = Novedad.filter(
        (item) => item.Valor != null && item.TablaId == 9
      ).map((item) => ({
        ...item,
        Valor: parseInt(item.Valor), // conversión de string a int
      }));

      var TipoServicio = this.$store.getters.MTablaSeleccion;
      this.ArrayTipoServicio = TipoServicio.filter(
        (item) => item.Valor != null && item.TablaId == 57
      ).map((item) => ({
        ...item,
        Valor: parseInt(item.Valor), // o Number(item.Valor) si prefieres mantener decimales
      }));

      var Sucursal = this.$store.getters.MDescSucursal;
      this.ArraySucursalId = Sucursal.filter((item) => item.SucursalId != 0);
      var ProductoID = this.$store.getters.MDescProducto;
      this.ArrayProductoId = ProductoID.filter((item) => item.ProductoID != 0);
      this.ArrayDesUnidadTiempo = Novedad.filter(
        (item) => item.Valor != null && item.TablaId == 52
      );

      this.ArrayDesBaseCalculo = Novedad.filter(
        (item) => item.Valor != null && item.TablaId == 53
      ).map((item) => ({
        ...item,
        Valor: parseInt(item.Valor), // o Number(item.Valor) si esperas decimales
      }));

      // Ciclo de comunicacion
      var Ciclo = this.$store.getters.MCiclo;
      this.ArrayCicloId = Ciclo.filter((item) => item.CodigoCiclo != 0);
    },
    // Actualizar carga
    ActualizarCargue() {
      if (this.editedIndex != -1) {
        // Actualizar
        this.editedItem = this.infoedit;
        this.clearcampos.Contrato_ID = false;
        this.readcampos.Contrato_ID = true;
        this.getNombrePersona();
        this.getDireccionPrincipal();
      } else {
        this.clearcampos.Contrato_ID = true;
        this.readcampos.Contrato_ID = false;
        if (this.infollaves != null) {
          this.editedItem.ContratoID =
            this.infollaves.Contrato != null ? this.infollaves.Contrato : null;
        }
      }
    },
  },
  mounted() {
    this.CargueCombos();
    this.ActualizarCargue();
  },
};
</script>
